import { render, staticRenderFns } from "./CustomComponentTemplate.vue?vue&type=template&id=b018f77a&scoped=true"
import script from "./CustomComponentTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./CustomComponentTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./CustomComponentTemplate.vue?vue&type=style&index=0&id=b018f77a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b018f77a",
  null
  
)

export default component.exports